import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountInput", "commissionPreview", "totalPreview"]
  static values = { commissionRate: { type: Number, default: 0 } }

  inputChanged() {
    const amountCents = (parseInt(this.amountInputTarget.value) || 0) * 100
    const commissionCents = Math.round(amountCents * this.commissionRateValue)
    const netCents = amountCents - commissionCents

    if (this.hasCommissionPreviewTarget) {
      this.commissionPreviewTarget.textContent = this.formatCop(commissionCents)
    }

    if (this.hasTotalPreviewTarget) {
      this.totalPreviewTarget.textContent = this.formatCop(netCents)
    }
  }

  formatCop(cents) {
    const cop = cents / 100
    return `$${cop.toLocaleString("es-CO")}`
  }
}
